import React from 'react'

import PdfSection from '@/components/misc/ReferralESignatureConsentPdf/components/PdfSection'
import SectionHeading from '@/components/misc/ReferralESignatureConsentPdf/components/SectionHeading'
import {
  REFERRAL_CONSENT_LETTER_VARIANT,
  REFERRAL_CONSENT_STAGE,
} from '@/lib/constants'
import { ReferralConsentStage } from '@/types/misc'
import { ReferralWithESignatureDetailsItem } from '@/types/responses/referrals'

interface Props {
  referral: ReferralWithESignatureDetailsItem
  consentStage: ReferralConsentStage
  shouldIncludeGroupVariantAppendix: boolean
}

const RegulationSection: React.FC<Props> = ({
  referral,
  consentStage,
  shouldIncludeGroupVariantAppendix,
}) => {
  const { toCompany } = referral
  const { complianceText, independenceStatus } = referral.eSignatureDetails
  const letterVariant = toCompany.incomingReferralsConsentLetterVariant
  const isReferralToFcaFirm = toCompany.isFcaFirm
  const toCompanyGroupName = toCompany.group?.name

  const isIntroductionConsent =
    consentStage === REFERRAL_CONSENT_STAGE.INTRODUCTION

  const isDefaultLetterVariant =
    letterVariant === REFERRAL_CONSENT_LETTER_VARIANT.DEFAULT

  const isGroupLetterVariant =
    letterVariant === REFERRAL_CONSENT_LETTER_VARIANT.INTRA_GROUP_TRANSFER

  return (
    <PdfSection>
      <SectionHeading className="mt-4">Regulation</SectionHeading>
      {complianceText.map((text, index) => (
        <p key={index}>{text}</p>
      ))}
      <p>
        {isIntroductionConsent
          ? 'We would, therefore, like to introduce you to '
          : 'We have therefore introduced you to '}
        {toCompany.presentationName}
        {independenceStatus &&
          ` ${isGroupLetterVariant ? 'which' : 'who'} offers ${independenceStatus} advice`}
        .
        {toCompany.companyIntroductionText &&
          ` ${toCompany.companyIntroductionText}`}
        {isReferralToFcaFirm && isDefaultLetterVariant && (
          <>
            {' '}
            They will issue you with their own terms and conditions and take
            responsibility for compliance with the requirements of the Financial
            Services and Markets Act 2000.
          </>
        )}
      </p>

      {isReferralToFcaFirm && isGroupLetterVariant && (
        <>
          <p>
            The firm providing advice to you will issue you with its own terms
            and conditions and take responsibility for compliance with the
            requirements of the Financial Services and Markets Act 2000.
          </p>

          <p>
            Where appropriate, your referral and relevant information may
            subsequently be transferred to another {toCompanyGroupName} firm so
            that the appropriate team can provide the services you have
            requested.
            {shouldIncludeGroupVariantAppendix && (
              <>
                {' '}
                Details of the other {toCompanyGroupName} firms are set out at
                the end of this letter.
              </>
            )}
          </p>
        </>
      )}
    </PdfSection>
  )
}

export default RegulationSection
